import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Container, Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Store } from '../Store';
import { toast } from 'react-toastify';
import { getError } from '../utils';

export default function EcranInscription() {
  const naviguer = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get('redirect');
  const redirect = redirectInUrl ? redirectInUrl : '/';

  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [mdp, setMdp] = useState('');
  const [confirmemdp, setConfirmeMdp] = useState('');

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { infoUtilisateur } = state;
  const gestionValidation = async (e) => {
    e.preventDefault();
    if (mdp !== confirmemdp) {
      toast.error('les mots de passe ne coincident pas!');
      return;
    }
    try {
      const { data } = await axios.post('/api/utilisateurs/inscription', {
        nom,
        email,
        mdp,
      });
      ctxDispatch({ type: 'CONNEXION_UTILISATEUR', payload: data });
      localStorage.setItem('infoUtilisateur', JSON.stringify(data));
      naviguer(redirect || '/');
    } catch (err) {
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    if (infoUtilisateur) {
      naviguer(redirect);
    }
  }, [naviguer, redirect, infoUtilisateur]);

  return (
    <Container className="small-container">
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <h1 className="my-3">Inscription</h1>
      <Form onSubmit={gestionValidation}>
        <Form.Group className="mb-3" controlId="nom">
          <Form.Label>Nom</Form.Label>
          <Form.Control
            type="name"
            required
            onChange={(e) => setNom(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            required
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Mot de passe</Form.Label>
          <Form.Control
            type="password"
            required
            onChange={(e) => setMdp(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Confirmer le mot de passe</Form.Label>
          <Form.Control
            type="password"
            required
            onChange={(e) => setConfirmeMdp(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <div className="mb-3">
          <Button type="submit">Inscription</Button>
        </div>
        <div className="mb-3">
          Vous avez déjà un compte ?{' '}
          <Link to={`/signin?redirect=${redirect}`}>Connexion</Link>
        </div>
      </Form>
    </Container>
  );
}
